// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/**
 * Returns the element matching a selector, an element unchanged, or a collection's first item.
 * Returns null for an unmatched selector and undefined for an absent or empty collection.
 */
export function assessmentRoot(el) {
  if (typeof el === "string") {
    return document.querySelector(el);
  }

  return el instanceof Element ? el : el?.[0];
}
